import { Link } from 'react-router-dom';
import ComicCard from './ComicCard';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-block px-4 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
              最近更新
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              最新上架的<span className="text-primary-600">韩漫章节</span>
            </h2>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
          >
            更多更新
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {latestUpdates.map(comic => (
            <ComicCard key={comic.id} comic={comic} size="small" />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 px-6 py-2.5 bg-primary-500 text-white text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多更新
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}